/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Pool, PoolInterface } from "../Pool";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "period",
        type: "uint256",
      },
    ],
    name: "DelayPeriodUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "threshold",
        type: "uint256",
      },
    ],
    name: "DelayThresholdUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
    ],
    name: "DelayedTransferAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "DelayedTransferExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    name: "EpochLengthUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "cap",
        type: "uint256",
      },
    ],
    name: "EpochVolumeUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "GovernorAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "GovernorRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "seqnum",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "address",
        name: "provider",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "LiquidityAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "MinAddUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "PauserAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "PauserRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "resetTime",
        type: "uint256",
      },
    ],
    name: "ResetNotification",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address[]",
        name: "_signers",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "_powers",
        type: "uint256[]",
      },
    ],
    name: "SignersUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "withdrawId",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "seqnum",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "refid",
        type: "bytes32",
      },
    ],
    name: "WithdrawDone",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "addGovernor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "addLiquidity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "addNativeLiquidity",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "addPauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "addseq",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "delayPeriod",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "delayThresholds",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "delayedTransfers",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "epochLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "epochVolumeCaps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "epochVolumes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
    ],
    name: "executeDelayedTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "governors",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "period",
        type: "uint256",
      },
    ],
    name: "increaseNoticePeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "isGovernor",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "isPauser",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lastOpTimestamps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "minAdd",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nativeWrap",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "noticePeriod",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "notifyResetSigners",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "pausers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "removeGovernor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "removePauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceGovernor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renouncePauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_signers",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_powers",
        type: "uint256[]",
      },
    ],
    name: "resetSigners",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "resetTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_period",
        type: "uint256",
      },
    ],
    name: "setDelayPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_thresholds",
        type: "uint256[]",
      },
    ],
    name: "setDelayThresholds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_length",
        type: "uint256",
      },
    ],
    name: "setEpochLength",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_caps",
        type: "uint256[]",
      },
    ],
    name: "setEpochVolumeCaps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amounts",
        type: "uint256[]",
      },
    ],
    name: "setMinAdd",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_weth",
        type: "address",
      },
    ],
    name: "setWrap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "ssHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "triggerTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_triggerTime",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "_newSigners",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_newPowers",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "_sigs",
        type: "bytes[]",
      },
      {
        internalType: "address[]",
        name: "_curSigners",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_curPowers",
        type: "uint256[]",
      },
    ],
    name: "updateSigners",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_msg",
        type: "bytes",
      },
      {
        internalType: "bytes[]",
        name: "_sigs",
        type: "bytes[]",
      },
      {
        internalType: "address[]",
        name: "_signers",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_powers",
        type: "uint256[]",
      },
    ],
    name: "verifySigs",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_wdmsg",
        type: "bytes",
      },
      {
        internalType: "bytes[]",
        name: "_sigs",
        type: "bytes[]",
      },
      {
        internalType: "address[]",
        name: "_signers",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_powers",
        type: "uint256[]",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "withdraws",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class Pool__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides & { from?: string | Promise<string> }): Promise<Pool> {
    return super.deploy(overrides || {}) as Promise<Pool>;
  }
  getDeployTransaction(overrides?: Overrides & { from?: string | Promise<string> }): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Pool {
    return super.attach(address) as Pool;
  }
  connect(signer: Signer): Pool__factory {
    return super.connect(signer) as Pool__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PoolInterface {
    return new utils.Interface(_abi) as PoolInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Pool {
    return new Contract(address, _abi, signerOrProvider) as Pool;
  }
}
